import React from "react"
import {
  type WorkItem,
  type WorkItemPushFieldType,
  WorkItemPushState,
} from "@digits-graphql/frontend/graphql-bearer"

export function useWorkItemPush(workItem: WorkItem, field: WorkItemPushFieldType) {
  return React.useMemo(() => {
    const push = workItem.pushes.find((p) => p.field === field)
    const hasError = push?.pushState === WorkItemPushState.Error
    return {
      hasError,
      ...push,
    }
  }, [workItem, field])
}

export function hasWorkItemPush(workItem: WorkItem, pushState: WorkItemPushState): boolean {
  return workItem.pushes.length > 0 && workItem.pushes.some((p) => p.pushState === pushState)
}

export function useHasWorkItemPush(workItem: WorkItem, pushState: WorkItemPushState): boolean {
  return React.useMemo(() => hasWorkItemPush(workItem, pushState), [pushState, workItem])
}

export function useWorkItemPushFirstError(workItem: WorkItem) {
  return React.useMemo(
    () => workItem.pushes?.find((p) => p.errorType !== undefined)?.errorType,
    [workItem]
  )
}
